<template>
	<view>
		<u-popup v-model="jiayouShow" mode="center" width="90%">
			<view class="jiayouShow-box">
				<image class="comOn" src="../../static/image/comeOn.gif" mode="aspectFit"></image>
				<text>加油成功</text>
			</view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		name:"comeOn",
		data() {
			return {
				jiayouShow: true
			};
		}
	}
</script>

<style lang="scss" scoped>
  .jiayouShow-box{
		padding: 40rpx 0;
		box-sizing: border-box;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.comOn{
			width: 332rpx;
			height: 332rpx;
		}
		text{
			display: inline-block;
			font-size: 32rpx;
			line-height: 2;
			margin: 40rpx 0;
		}
	}
</style>
